import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../utils/firebase-config";

export function getUser(uid: string) {
  return getDoc(doc(db, "users", uid));
}

export function saveUserFirstLogin(uid: string) {
  return setDoc(doc(db, "users", uid), {
    firstLoginTime: new Date()
  });
}

export function saveCustomerId({
  uid,
  customerId
}: {
  uid: string;
  customerId: string;
}) {
  return updateDoc(doc(db, "users", uid), { customerId });
}

export function saveUserPlan({
  uid,
  planType
}: {
  uid: string;
  planType: string;
}) {
  return updateDoc(doc(db, "users", uid), { planType });
}

export function saveSubscriptionId({
  uid,
  subscriptionId,
  planType
}: {
  uid: string;
  subscriptionId: string | null;
  planType: string;
}) {
  return updateDoc(doc(db, "users", uid), { subscriptionId, planType });
}
